import { IconButton } from '@aibi/ui';
import { CircleAlert, X } from 'lucide-react';
import { useEffect } from 'react';
import { useWorkspace, useWorkspaceActions } from '../../state/workspace-context';

const DISMISS_AFTER_MS = 5000;

/** Aviso no bloqueante cuando un comando se rechaza (drop invalido, limite...). */
export function RejectionToast() {
  const { rejection } = useWorkspace();
  const { dismissRejection } = useWorkspaceActions();
  const sequence = rejection?.sequence;

  useEffect(() => {
    if (sequence === undefined) return;
    const timer = setTimeout(dismissRejection, DISMISS_AFTER_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [sequence, dismissRejection]);

  return (
    <div
      aria-live="assertive"
      className="pointer-events-none fixed bottom-10 left-1/2 z-50 -translate-x-1/2"
    >
      {rejection && (
        <div
          role="alert"
          className="pointer-events-auto flex max-w-md items-center gap-2 rounded-lg border border-destructive/30 bg-popover py-2 pl-3 pr-1.5 text-sm text-popover-foreground shadow-overlay"
        >
          <CircleAlert aria-hidden className="size-4 shrink-0 text-destructive" />
          <span className="flex-1">{rejection.value.message}</span>
          <IconButton label="Cerrar aviso" onClick={dismissRejection}>
            <X />
          </IconButton>
        </div>
      )}
    </div>
  );
}
